const state = {
    loading: true
}

// getters
const getters = {
    loading: state => state.loading
}

// actions
const actions = {
    start ({ commit }) {
        commit('setLoading', true)
    },
    stop ({ commit }) {
        commit('setLoading', false)
    }

}

// mutations
const mutations = {
    setLoading (state, loading) {
        state.loading = loading
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
